<LayoutMain>
  <template #header>
    <PageHeader :icon="Users" :title="t('activeUsers.titleEveryone')" :subtitle="headerSubtitle" />
  </template>

  <div class="space-y-6">
    <ErrorDisplay v-if="userStore.error" :message="userStore.error" />

    <ExploringView
      :active-users="activeUsers"
      :loading="loadingExploring"
      @toggle-like="handleToggleLike"
      @view-profile="handleViewProfile"
      @start-exploring="handleStartExploring"
    />

    <EveryoneView :exclude-ids="activeUserIds" class="pt-6" />
  </div>
</LayoutMain>
